import { useState, useEffect } from 'react';
import { fetchJobById } from '../services/jobsAPI';
import { Job } from '../types';

export const useJobDetail = (jobId: string) => {
  const [job, setJob] = useState<Job | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!jobId) {
      setError("No job ID provided.");
      setIsLoading(false);
      return;
    }

    const loadJobDetail = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const fetchedJob = await fetchJobById(jobId);
        setJob(fetchedJob);
      } catch (err) {
        if (err instanceof Error) {
            setError(err.message);
        } else {
            setError('An unknown error occurred while fetching the job details.');
        }
        console.error(err);
      } finally {
        setIsLoading(false);
      }
    };

    loadJobDetail();
  }, [jobId]);

  return { job, isLoading, error };
};
